var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSquare2White(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7907 22H9.2093C4.15814 22 2 19.8419 2 14.7907V9.2093C2 4.15814 4.15814 2 9.2093 2H14.7907C19.8419 2 22 4.15814 22 9.2093V14.7907C22 19.8419 19.8419 22 14.7907 22ZM9.2093 3.39535C4.92093 3.39535 3.39535 4.92093 3.39535 9.2093V14.7907C3.39535 17.3244 3.92789 18.8936 5.24813 19.7536C5.92201 17.158 8.72213 15.2197 12.0006 15.2197C15.2802 15.2197 18.0728 17.151 18.7515 19.7539C20.072 18.8939 20.6047 17.3246 20.6047 14.7907V9.2093C20.6047 4.92093 19.0791 3.39535 14.7907 3.39535H9.2093ZM6.72063 20.0598C7.38063 20.1898 8.13063 20.2498 9.00063 20.2498H15.0006C15.8706 20.2498 16.6206 20.1898 17.2806 20.0598C16.7506 18.1398 14.5606 16.7197 12.0006 16.7197C9.44063 16.7197 7.25063 18.1398 6.72063 20.0598ZM7.66992 9.58C7.66992 11.97 9.60992 13.92 11.9999 13.92C14.3899 13.92 16.3299 11.97 16.3299 9.58C16.3299 7.19002 14.3899 5.25 11.9999 5.25C9.60992 5.25 7.66992 7.19002 7.66992 9.58ZM9.16992 9.58C9.16992 8.02002 10.4399 6.75 11.9999 6.75C13.5599 6.75 14.8299 8.02002 14.8299 9.58C14.8299 11.15 13.5599 12.42 11.9999 12.42C10.4399 12.42 9.16992 11.15 9.16992 9.58Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSquare2White);
export default __webpack_public_path__ + "static/media/user-square-2-white.c3c886b25827be9dfa7dc498d6f7bb25.svg";
export { ForwardRef as ReactComponent };